<template>
    <div class="meta-link" :class="bemFacet" v-bind="cmsEditHelperAttrs">
        <router-link class="u-reset meta-link--item" :to="content.path">
            <cmp-icon class="meta-link--icon" :symbol="content.icon" size="x-small"></cmp-icon>
            <span class="meta-link--label" v-text="content.label"></span>
        </router-link>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
            bemMixin('meta-link'),
        ],
    };
</script>



// WEBPACK FOOTER //
// index.vue?4922f49a